/* eslint-disable @eslint-react/no-array-index-key */
import React from "react";

interface HighlightedTextProps {
  text: string;
  highlightTerm?: string;
}

const escapeRegExp = (string: string) => string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const HighlightedText: React.FC<HighlightedTextProps> = ({ text, highlightTerm }) => {
  if (!highlightTerm) return <>{text}</>;

  const escapedTerm = escapeRegExp(highlightTerm);
  const parts = text.split(new RegExp(`(${escapedTerm})`, "gi"));
  return (
    <>
      {parts.map((part, i) =>
        part.toLowerCase() === highlightTerm.toLowerCase() ? (
          <mark key={i} className="bg-yellow-100 in-data-highlighted:bg-yellow-400 no-underline">
            {part}
          </mark>
        ) : (
          <span key={i}>{part}</span>
        ),
      )}
    </>
  );
};
